function initShare() {
    let navigatorShare = navigator.share;

    let $shareLinks = document.querySelectorAll("[data-share-title]");

    for(let $link of $shareLinks) {
        if(navigatorShare) {
            $link.style.display = "inline";

            $link.addEventListener("click", _ => { 
                let title = $link.getAttribute("data-share-title");
                let url = $link.getAttribute("data-share-url");
                
                navigator.share({
                    title: title,
                    url: url,
                })                
                .catch((error) => console.log('Error sharing', error));
            });
        }
    }
}

export default initShare;